import React from "react";
import Styles from "./ConnectionAcceptModal.module.css";
import { Modal, CircularProgress } from "@mui/material";

const ConnectionAcceptModal = ({
  open,
  handleClose,
  onConfirm,
  content,
  insideViewModal,
  insideTermsModal,
  loading = false,
}) => {
  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div className={` ${Styles.createEditModalCont}`}>
          {/* <div
            className={`headingText display_flex_row_center ${Styles.connectHead}`}
          >
            Connect
          </div> */}
          <div
            className={`headingText display_flex_row_center ${Styles.connectHead}`}
          >
            {insideTermsModal
              ? content === "finalize"
                ? "Confirmation"
                : content === "close"
                  ? "Close Terms & Conditions"
                  : `Confirmation`
              : insideViewModal
                ? `Confirmation`
                : `Confirmation`}
          </div>
          {/* {insideViewModal ? (
            <div
              className={Styles.headerSection}
              style={{ backgroundColor: " #fffffff0;" }}
            >
              <span>Do you want to <span style={{fontWeight:}}>{content.toLowerCase()}</span></span>
              
              <span> the connection request?</span>
            </div>
          ) : (
            <div
              style={{ backgroundColor: " #fffffff0;" }}
              className={Styles.headerSection}
            >
              <span>Do you want to send a </span>
             
              <span>{content}</span>
            </div>
          )} */}
          {insideTermsModal ? (
            <div
              className={Styles.headerSection}
              style={{ backgroundColor: " #fffffff0;" }}
            >
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <span>
                  {content === "finalize"
                    ? "Do you want to"
                    : content === "close"
                      ? "Do you want to"
                      : "Do you want to"}{" "}
                  <span style={{ fontWeight: "500" }}>
                    {content === "finalize"
                      ? "finalize"
                      : content === "close"
                        ? "close"
                        : content.toLowerCase()}
                  </span>{" "}
                  the terms and conditions?
                </span>

                <span>
                  {content === "finalize" && (
                    <div style={{ fontSize: "14px", color: "#666" }}>
                      <span style={{ fontWeight: "bold" }}>Note: </span> Please
                      ensure these values are correct. After confirmation from
                      the counterparty, <br /> they cannot be changed.
                    </div>
                  )}
                </span>
              </span>

              {/* <span> the terms and conditions?</span> */}
            </div>
          ) : insideViewModal ? (
            <div
              className={Styles.headerSection}
              style={{ backgroundColor: " #fffffff0;" }}
            >
              <span>
                Do you want to{" "}
                <span
                  style={{
                    fontWeight: "600",
                    color: "var(--primary-color-text)",
                  }}
                >
                  {content.toLowerCase()}
                </span>{" "}
                the connection request?
              </span>

              {/* <span> the connection request?</span> */}
            </div>
          ) : (
            <div
              style={{ backgroundColor: " #fffffff0;" }}
              className={Styles.headerSection}
            >
              <span>Do you want to send a {content}</span>{" "}
              {/* <span> {content}</span> */}
            </div>
          )}
          <div className={Styles.buttonSection}>
            <div onClick={handleClose}>
              <span
                className={Styles.onHoverButton}
                style={{
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.6 : 1,
                }}
              >
                No
              </span>
            </div>
            <div onClick={loading ? undefined : onConfirm}>
              <div>
                <span
                  className={Styles.onHoverButton}
                  style={{
                    cursor: loading ? "not-allowed" : "pointer",
                    opacity: loading ? 0.8 : 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  {loading ? (
                    <>
                      <span
                        style={{
                          color: "var(--fourth-color-text",
                          fontWeight: "400",
                        }}
                      >
                        Processing...
                      </span>
                    </>
                  ) : (
                    "Yes"
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ConnectionAcceptModal;
